import { render, staticRenderFns } from "./MenuGroup.vue?vue&type=template&id=4f81f13f&scoped=true"
import script from "./MenuGroup.vue?vue&type=script&lang=js"
export * from "./MenuGroup.vue?vue&type=script&lang=js"
import style0 from "./MenuGroup.vue?vue&type=style&index=0&id=4f81f13f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f81f13f",
  null
  
)

export default component.exports